/* Macriz: la burbuja flotante de WhatsApp no debe tapar los botones de compra (celular).
   Marca <html> con la clase mcz-wa-tapa-boton solo mientras algún .product-form__buttons
   pase por la franja donde está la burbuja; el CSS (macriz-custom.css) la oculta en ese momento. */
(function () {
  var raiz = document.documentElement;
  var pendiente = false;

  function revisar() {
    pendiente = false;
    var tapa = false;
    var burbuja = document.querySelector('.wa-preview-corner-button-container');
    var botones = document.querySelectorAll('.product-form__buttons');

    if (burbuja && botones.length && window.matchMedia('(max-width: 749px)').matches) {
      var b = burbuja.getBoundingClientRect();
      for (var i = 0; i < botones.length; i++) {
        var r = botones[i].getBoundingClientRect();
        if (r.height > 0 && r.bottom > b.top - 16 && r.top < b.bottom + 16) {
          tapa = true;
          break;
        }
      }
    }

    raiz.classList.toggle('mcz-wa-tapa-boton', tapa);
  }

  function programar() {
    if (pendiente) return;
    pendiente = true;
    window.setTimeout(revisar, 50);
  }

  window.addEventListener('scroll', programar, { passive: true });
  window.addEventListener('resize', programar);
  window.addEventListener('load', programar);
  document.addEventListener('DOMContentLoaded', programar);
  /* la app de WhatsApp inyecta la burbuja después de cargar la página */
  [1000, 3000, 6000].forEach(function (ms) {
    window.setTimeout(programar, ms);
  });
})();
